// Add your custom JS here.

// Mega Menu Logic
(function ($) {
  $(document).ready(function () {
    $('.main-nav__dropdown-link .dropdown__close').on('keypress', function (e) {
      if (e.which == 13 || e.which == 32) {
        $(e.currentTarget).trigger('click');
      }
    });
    

    $('.header__navigation-menus .main-nav__dropdown-link').on('click', function (e) {
      e.preventDefault();

      var $target = $(e.currentTarget);
      var $dropdownTarget = $('#' + $target.attr('data-dropdown'));

      if ($target.hasClass('active')) {

        $('.header__navigation-menus .main-nav__dropdown-link').removeClass('transition-active active');
        $('.header__navigation-menus .dropdown').removeClass('transition-active active');

      } else {

        $('.header__navigation-menus .main-nav__dropdown-link').removeClass('active');
        $('.header__navigation-menus .dropdown').removeClass('active');

        $target.toggleClass('transition-active');
        $dropdownTarget.toggleClass('transition-active');

        setTimeout(function () {
          $target.toggleClass('transition-active active');
          $dropdownTarget.toggleClass('transition-active active');
        }, (0));

      }
    });

    $('.dropdown__close, .dropdown__backdrop').on('click', function () {
      $('.main-nav__dropdown-link').removeClass('active');
      $('.dropdown').removeClass('active');
    });

    $('.mobile-menu .main-nav__dropdown-link').on('click', function (e) {
      e.preventDefault();

      var $target = $(e.currentTarget);
      var $dropdownTarget = $('#' + $target.attr('data-dropdown'));

      if ($target.hasClass('active')) {

        $('.mobile-menu .main-nav__dropdown-link').removeClass('transition-active active');
        $target.parent().find('.dropdown').removeClass('transition-active active');

      } else {

        $('.mobile-menu .main-nav__dropdown-link').removeClass('active');
        $target.parent().parent().find('.dropdown').removeClass('transition-active active');
        $target.parent().find('.dropdown').addClass('transition-active active');

        $target.toggleClass('transition-active');
        $dropdownTarget.toggleClass('transition-active');

        setTimeout(function () {
          $target.toggleClass('transition-active active');
          $dropdownTarget.toggleClass('transition-active active');
        }, (0));

      }
    });

    $('.hamburger-menu-toggle').click(function () {
      if ($(this).hasClass('menu-opened')) {
        $(this).removeClass('menu-opened');
        $('.mobile-menu').removeClass('menu-opened');
      } else {
        $(this).addClass('menu-opened');
        $('.mobile-menu').addClass('menu-opened');
      }
    });

    // search
    $('header .header__content .search-wrp').click(function () {

      if (!$('header .search-container').hasClass('search-show')) {
        $('header .search-container').addClass('search-show');
        $(this).addClass('search-show');
      } else {
        $('header .search-container').removeClass('search-show');
        $(this).removeClass('search-show');
      }

    });

    $('header .mobile-menu-wrp .mobile-search-wrp').click(function () {

      if (!$('header .search-container').hasClass('search-show')) {
        $('header .search-container').addClass('search-show');
        $(this).addClass('search-show');
      } else {
        $('header .search-container').removeClass('search-show');
        $(this).removeClass('search-show');
      }

    });

    $('header .search-container .search-close').click(function () {
      $('header .search-container').removeClass('search-show');
      $('header .header__content .search-wrp').removeClass('search-show');
    });

    $('header .search-container .search-wrp .search-icon').click(function () {
      $('header .search-container .search-wrp .search-form-wrp form').submit();
    });

    // Featured Products Slider
    if ($('.sp-featured-products-section .products-slider, .sp-featured-products .products-slider').length) {
      $('.sp-featured-products-section .products-slider, .sp-featured-products .products-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        // autoplay: true,
        // autoplaySpeed: 3000,
        infinite: true,
        arrows: true,
        dots: false,
        adaptiveHeight: false,
        responsive: [{
          breakpoint: 992,
          settings: {
            slidesToShow: 2
          }
        }, {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        }, {
          breakpoint: 576,
          settings: {
            slidesToShow: 1
          }
        }]
        
      });

      $('.sp-featured-products-section .slick-prev, .sp-featured-products .slick-prev').attr('aria-label', 'Previous slide');
      $('.sp-featured-products-section .slick-next, .sp-featured-products .slick-next').attr('aria-label', 'Next slide');
    }

    /* Product gallery + Vimeo: initialized in single-products.php inline script. */




    $('.fb-button').on('click', function () {
      $('.step-1').hide();
      $('.step-2').show();
    });

    $('.back-button').on('click', function () {
      $('.step-2').hide();
      $('.step-1').show();
    });

    // accordion
    $('.accordion__header').on('click', function () {
      let $item = $(this).closest('.accordion__item');
      let $content = $item.find('.accordion__content');
      $content.slideToggle(300, function () {
        $item.toggleClass('acc-open', $content.is(':visible'));
      });
    });


  function addMenuActive() {
    const currentURL = new URL(location.href);
    const currentPathname = getFinalPathSegment(currentURL.pathname); 
    const currentSearchParams = currentURL.search;

    if (!currentPathname) return;

    $('#main-navigation li').each(function () {
        const $li = $(this);
        const $topLink = $li.find('> a.main-nav__top-link');
        let isActive = false;

        if ($topLink.length) {
            const linkURL = new URL($topLink.attr('href'), location.origin);
            const linkPathname = getFinalPathSegment(linkURL.pathname);

            if (currentPathname === linkPathname || checkPartialMatch(currentPathname, linkPathname)) {
                isActive = true;
            }
        }

        $li.find('.dropdown__right__column a').each(function () {
            const nestedLinkURL = new URL($(this).attr('href'), location.origin);
            const nestedLinkPathname = getFinalPathSegment(nestedLinkURL.pathname);

            if (currentPathname === nestedLinkPathname || checkPartialMatch(currentPathname, nestedLinkPathname)) {
                isActive = true;
                return false;
            }
        });
        $li.find('.dropdown__left a').each(function () {
          const leftLinkURL = new URL($(this).attr('href'), location.origin);
          const leftLinkPathname = getFinalPathSegment(leftLinkURL.pathname);

          if (currentPathname === leftLinkPathname || checkPartialMatch(currentPathname, leftLinkPathname)) {
              isActive = true;
              return false;
          }
      });

        if (isActive) {
            $topLink.addClass('current-page');
        }
    });
}

  function getFinalPathSegment(pathname) {
      const cleanedPath = pathname.replace(/[#?].*$/, '');
      const segments = cleanedPath.split('/').filter(Boolean);
      return segments.length ? segments[segments.length - 1] : '';
  }

  function checkPartialMatch(currentPath, linkPath) {
      if (!currentPath || !linkPath) return false;

      const currentSegments = currentPath.split('/');
      const linkSegments = linkPath.split('/');

      return currentSegments[currentSegments.length - 1] === linkSegments[linkSegments.length - 1];
  }

addMenuActive();


    $('.icon-play').on('click', function () {
      $(this).removeClass('icon-play');
      let video = $(this).find('video')[0];
      if (video) {
        video.setAttribute('controls', 'controls');
      }
    });


    // default modal open
    $('.open-modal').on('click', function (e) {
        e.preventDefault();
        const modalId = $(this).data('modal');
        const targetModal = $(`#${modalId}`);
        targetModal.addClass('open');
        $('body').css('overflow', 'hidden');
    });

    // Close modal
    $(document).on('click', '.product-modal', function (e) {
        const modal = $(this);
        if ($(e.target).is(modal) || $(e.target).hasClass('modal-close')) {
            modal.removeClass('open');
            $('body').css('overflow', '');
        }
    });

    // pardot iframe auto height
    if ( jQuery('#pardot-iframe').length ) {
      jQuery('#pardot-iframe').seamless({
        fallbackText: ''
      });
    }



  
    $('.sp-faq__question').click(function() {
      const content = $(this).next('.sp-faq__content'); 
      const parentItem = $(this).closest('.sp-faq__item');
  
      if (content.is(':visible')) {
          content.slideUp(250);
          parentItem.removeClass('active');
      } else {
          content.slideDown(250);
          parentItem.addClass('active');
      }
    });
   
    if ($('.top-banner').length) {
      $('.top-banner .marquee').slick({
        speed: 11000,
        autoplay: true,
        autoplaySpeed: 0,
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        infinite: true,
        arrows: false,
        buttons: false
      });
    
      $('.top-banner .marquee').on('afterChange', function(event, slick, current) {
        if (current === slick.$slides.length - 1) {
          slick.slickPause();
          slick.slickGoTo(0, true);
          slick.slickPlay();
        }
      });
    }
   
    function toggleTopBanner() {
      const banner = document.querySelector('.top-banner');
      if (!banner) return;
  
      const scrollTop = window.scrollY;
      const maxHeight = 32;
      const newHeight = Math.max(0, maxHeight - scrollTop);
  
      banner.style.height = `${newHeight}px`;
    }
  
    toggleTopBanner();
    window.addEventListener('scroll', toggleTopBanner, { passive: true });

     //END ready
  });


  /* function appendUTMParametersToAllLinks() {
    const currentUrl = window.location.href;
    const urlParts = currentUrl.split('?');

    if (urlParts.length < 2) return;

    const queryString = currentUrl.slice(currentUrl.indexOf('?') + 1);
    const queryParams = queryString.split('&');
    let utmParams = '';

    for (let i = 0; i < queryParams.length; i++) {
      if (queryParams[i].toLowerCase().includes('utm')) {
        utmParams += (utmParams ? '&' : '') + queryParams[i];
      }
    }

    if (!utmParams) return;

    jQuery('body a').each(function () {
      const $el = jQuery(this);
      let href = $el.attr('href');

      if (!href || href === '#' || href === 'javascript:;') return;

      href += '?' + utmParams;
      $el.attr('href', href);
    });
  }
  appendUTMParametersToAllLinks(); */


  jQuery(function ($) {
    $('.specification-item.has-children > .specification-main').on('click', function () {
      const parent = $(this).closest('.specification-item');
      const subList = parent.find('.specification-sub-list').first();
  
      if (parent.hasClass('open')) {
        parent.removeClass('open');
        subList.stop(true, true).slideUp(300);
      } else {
        parent.addClass('open');
        subList.stop(true, true).slideDown(300);
      }
    });
  });
  

  //END
})(jQuery);

(function () {

  const COOKIE_NAME = 'utmParams';
  const COOKIE_MAX_AGE_SECONDS = 60 * 24 * 60 * 60;
  let currentUrl = null;
  try {
    currentUrl = new URL(document.URL);
  } catch (err) {
    currentUrl = null;
  }
  const pageQuery = currentUrl ? currentUrl.searchParams : new URLSearchParams();
  const UTM_PARAM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

  const d365FieldFromUrlParam = [
    { formField: 'tab_campaignsource', urlParam: 'utm_source' },
    { formField: 'tab_campaignmedium', urlParam: 'utm_medium' },
    { formField: 'tab_campaignname', urlParam: 'utm_campaign' },
    { formField: 'tab_campaignterm', urlParam: 'utm_term' },
    { formField: 'tab_campaigncontent', urlParam: 'utm_content' },
    { formField: 'tab_utm_source', urlParam: 'utm_source' }
  ];

  let marketingFormsAlreadyFilled = new WeakSet();

  function marketingCookieStorageAllowed() {
    return window.__spAllowUtmCookie === true;
  }

  function readCookieValue(cookieName) {
    const escaped = cookieName.replace(/[.$?*|{}()[\]\\/+^]/g, '\\$&');
    const match = document.cookie.match(new RegExp('(?:^|; )' + escaped + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function writeCookieValue(cookieName, value, maxAgeSeconds) {
    const secureFlag = currentUrl && currentUrl.protocol === 'https:' ? ';Secure' : '';
    document.cookie =
      cookieName +
      '=' +
      encodeURIComponent(value) +
      ';path=/;max-age=' +
      maxAgeSeconds +
      ';SameSite=Lax' +
      secureFlag;
  }

  function safeCurrentPageSource() {
    if (!currentUrl || !/^https?:$/.test(currentUrl.protocol)) {
      return '';
    }
    return currentUrl.origin + currentUrl.pathname + currentUrl.search + currentUrl.hash;
  }

  function parseUtmJsonFromCookie(raw) {
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (err) {
      return null;
    }
  }

  function utmSnapshotFromCurrentUrl() {
    const snapshot = {};
    UTM_PARAM_KEYS.forEach(function (name) {
      const value = pageQuery.get(name);
      if (value) snapshot[name] = value;
    });
    return Object.keys(snapshot).length ? snapshot : null;
  }

  function snapshotHasAtLeastOneValue(snapshot) {
    if (!snapshot || typeof snapshot !== 'object') return false;
    let key;
    for (key in snapshot) {
      if (!Object.prototype.hasOwnProperty.call(snapshot, key)) continue;
      if (snapshot[key] != null && String(snapshot[key]).length > 0) return true;
    }
    return false;
  }


  function restoreMarketingConsentFromCookies() {
    const fromCookie = parseUtmJsonFromCookie(readCookieValue(COOKIE_NAME));
    if (snapshotHasAtLeastOneValue(fromCookie)) {
      window.__spAllowUtmCookie = true;
    }
  }

  function saveFirstTouchUtmFromUrlIfCookieEmpty() {
    if (!marketingCookieStorageAllowed()) return;

    const urlSnap = utmSnapshotFromCurrentUrl();
    if (!snapshotHasAtLeastOneValue(urlSnap)) return;

    const existing = parseUtmJsonFromCookie(readCookieValue(COOKIE_NAME));
    if (snapshotHasAtLeastOneValue(existing)) return;

    writeCookieValue(COOKIE_NAME, JSON.stringify(urlSnap), COOKIE_MAX_AGE_SECONDS);
  }

  function valueForUrlParam(urlParamName) {
    if (!marketingCookieStorageAllowed()) {
      return pageQuery.get(urlParamName) || '';
    }

    const fromCookie = parseUtmJsonFromCookie(readCookieValue(COOKIE_NAME));
    if (fromCookie && typeof fromCookie === 'object') {
      const stored = fromCookie[urlParamName];
      if (stored != null && String(stored).length > 0) {
        return String(stored);
      }
    }

    return pageQuery.get(urlParamName) || '';
  }

  function appendUtmParametersToInternalLinks() {
    
    const snapshot = utmSnapshotFromCurrentUrl();
    if (!snapshot) return;

    document.querySelectorAll('a[href]').forEach(function (link) {
      const href = link.getAttribute('href');
      if (!href || href === '#' || href.indexOf('javascript:') === 0) return;
      if (href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return;

      let url;
      try {
        const baseOrigin = currentUrl ? currentUrl.origin : (document.location ? document.location.origin : '');
        if (!baseOrigin) return;
        url = new URL(href, baseOrigin);
      } catch (err) {
        return;
      }

      if (currentUrl && url.origin !== currentUrl.origin) return;

      Object.keys(snapshot).forEach(function (key) {
        if (!snapshot[key]) return;
        if (!url.searchParams.has(key)) {
          url.searchParams.set(key, snapshot[key]);
        }
      });

      const normalizedHref = url.pathname + url.search + url.hash;
      if (href !== normalizedHref) {
        link.setAttribute('href', normalizedHref);
      }
    });
  }

  function setInputValueAndNotify(form, fieldName, value) {
    if (!value) return false;
    const input = form.querySelector('[name="' + fieldName + '"]');
    if (!input) return false;
    input.value = value;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function fillMarketingFormWithUtm(form) {
    if (!form) return;

    d365FieldFromUrlParam.forEach(function (mapping) {
      const value = valueForUrlParam(mapping.urlParam);
      if (!value) return;
      setInputValueAndNotify(form, mapping.formField, value);
    });

    setInputValueAndNotify(form, 'tab_pagesource', safeCurrentPageSource());
  }

  function fillAllMarketingFormsNotYetHandled() {
    document.querySelectorAll('form.marketingForm').forEach(function (form) {
      if (marketingFormsAlreadyFilled.has(form)) return;
      fillMarketingFormWithUtm(form);
      marketingFormsAlreadyFilled.add(form);
    });
  }

  function grantMarketingUtmCookieConsent() {
    window.__spAllowUtmCookie = true;
    saveFirstTouchUtmFromUrlIfCookieEmpty();
    appendUtmParametersToInternalLinks();
    marketingFormsAlreadyFilled = new WeakSet();
    requestAnimationFrame(fillAllMarketingFormsNotYetHandled);
  }

  window.__spUtmGrantStorageConsent = grantMarketingUtmCookieConsent;
  document.addEventListener('sp-utm-storage-allowed', grantMarketingUtmCookieConsent);


  function syncUtmFromCookiebotMarketingIfConsented() {
    try {
      if (typeof window.Cookiebot === 'undefined' || !window.Cookiebot.consent) {
        return;
      }
      if (window.Cookiebot.consent.marketing === true) {
        grantMarketingUtmCookieConsent();
      }
    } catch (err) {
      /* ignore */
    }
  }

  ['CookiebotOnAccept', 'CookiebotOnLoad'].forEach(function (eventName) {
    window.addEventListener(eventName, syncUtmFromCookiebotMarketingIfConsented);
  });

  window.setTimeout(syncUtmFromCookiebotMarketingIfConsented, 500);
  window.setTimeout(syncUtmFromCookiebotMarketingIfConsented, 2500);

  restoreMarketingConsentFromCookies();
  saveFirstTouchUtmFromUrlIfCookieEmpty();
  appendUtmParametersToInternalLinks();
  requestAnimationFrame(fillAllMarketingFormsNotYetHandled);

  document.addEventListener('d365mkt-afterformload', function () {
    requestAnimationFrame(fillAllMarketingFormsNotYetHandled);
  });

  document.addEventListener('submit', function (event) {
    const target = event.target;
    const form =
      target && typeof target.closest === 'function'
        ? target.closest('form.marketingForm')
        : null;
    if (!form) return;
    fillMarketingFormWithUtm(form);
  }, true);
})();